import dayjs from '../../utils/dayjs';
import { Text, InlineGrid, Page, BlockStack, LegacyCard, CalloutCard, ExceptionList } from '@shopify/polaris';
import { EmailIcon, LocationIcon, PhoneIcon } from '@shopify/polaris-icons';

import { useState, useCallback, useEffect } from 'react';
import 'media/css/user_profile.scss';

import { Helmet } from 'react-helmet-async';
import { useAuth } from 'context/AuthContext';
import UserProfileLoading from 'components/userProfileLoading';
import { useNavigate } from 'react-router-dom';
import StarRating from 'components/starRating';
import { useGetEntity } from 'queries/user.query';
import UserProfileHeader from './components/UserProfileHeader';

/************************************************************ *
 * MAIN
 * Private route
 ************************************************************ */

export default function MyProfile() {
  const { user: currentUserData } = useAuth();
  const { mutate: getEntity, data: profileData, isPending } = useGetEntity();

  const history = useNavigate();

  /** Nếu load theo profile người dùng thì thực hiện nó ở đây */
  useEffect(() => {
    getEntity(currentUserData.user_id);
  }, [currentUserData]);

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>Trang chủ</title>
      </Helmet>
      <Page>
        <UserProfileHeader />
        <br />
        <br />

        {profileData && (
          <InlineGrid columns={{ xs: '1', sm: '1', md: '1', lg: ['oneThird', 'twoThirds'] }} gap="400">
            <div>
              {isPending ? (
                <UserProfileLoading />
              ) : (
                <LegacyCard title="Thông tin" actions={[{ content: 'Chỉnh sửa', onAction: () => history('/edit-my-profile') }]}>
                  <LegacyCard.Section>
                    <br />
                    <BlockStack gap={'200'}>
                      <ExceptionList
                        items={[
                          { icon: EmailIcon, description: profileData?.user_email ?? '-' },
                          { icon: PhoneIcon, description: profileData?.user_phonenumber ?? '-' },
                          { icon: LocationIcon, description: profileData?.user_address },
                        ]}
                      />
                    </BlockStack>
                  </LegacyCard.Section>

                  <LegacyCard.Section subdued title="">
                    <Text as="p" variant="bodyMd">
                      Tham gia từ {dayjs(new Date(Number(profileData?.createdAt))).format('DD-MM-YYYY')}
                    </Text>
                    {profileData?.user_rate > 0 ? (
                      <div>
                        <StarRating num={profileData?.user_rate} />
                        <Text as="span" tone="subdued">{`${profileData?.user_rate_count} đánh giá`}</Text>
                      </div>
                    ) : null}
                  </LegacyCard.Section>
                </LegacyCard>
              )}
            </div>

            <div>
              {(!currentUserData.user_address || !currentUserData.user_birthday || !currentUserData.user_avatar) && (
                <CalloutCard
                  title="Bạn chưa cập nhật thông tin"
                  illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
                  primaryAction={{ content: 'Chỉnh sửa hồ sơ', url: '/edit-my-profile' }}
                >
                  <p>Điền đầy đủ thông tin và nhận về những phần quà đầu tiên.</p>
                </CalloutCard>
              )}
            </div>
          </InlineGrid>
        )}
      </Page>
    </>
  );
}

